module.exports = __webpack_public_path__ + "static/hero-cc2417971429b9abc55eaa4983b09191.png";